import { Dispatch, SetStateAction, useState } from 'react';
import toast from 'react-hot-toast';

export interface UseProps {
  handleChange: (fileList: FileList) => void;
  handleRemove: (file: File) => void;
  fileTypes: string[];
  files: File[];
  setFiles: Dispatch<SetStateAction<File[]>>;
}

const useUploadFast = (): UseProps => {
  const [files, setFiles] = useState<File[]>([]);
  const fileTypes = ['txt'];

  const handleChange = (fileList: FileList): void => {
    const newFiles = Array.from(fileList); // Converte FileList para array

    setFiles((prev) => {
      // Verifica se já existem 10 arquivos ou se a adição ultrapassaria o limite
      if (prev.length + newFiles.length > 10) {
        toast.error('Você pode adicionar no máximo 10 arquivos.');
        return prev; // Não adiciona novos arquivos
      }

      const updatedFiles = [...prev];

      newFiles.forEach((file) => {
        const exists = prev.some(
          (f) => f.name === file.name && f.size === file.size
        );
        if (!exists) {
          updatedFiles.push(file);
        } else {
          toast.error(`O arquivo ${file.name} já foi adicionado.`);
        }
      });

      return updatedFiles;
    });
  };
  const handleRemove = (fileToRemove: File): void => {
    setFiles((prev) =>
      prev.filter(
        (file) =>
          file.name !== fileToRemove.name || file.size !== fileToRemove.size
      )
    );
  };

  return {
    files,
    fileTypes,
    handleChange,
    handleRemove,
    setFiles,
  };
};

export default useUploadFast;
